type SeverityLevel = "info" | "warning" | "error";

const ERROR_CODES = [
    "F821", // undefined name `name`
    "E902", // IOError
    "E999", // SyntaxError
];

/**
 * Returns the severity level for a given error code. This currently mimicks
 * the behavior of the Ruff LSP (https://github.com/astral-sh/ruff-lsp), which
 * hard-codes three "error" codes and treats everything else as a warning.
 * The "info" level is not currently used.
 */
export const mapErrorCodeToSeverity = (errorCode: string): SeverityLevel => {
    if (ERROR_CODES.includes(errorCode)) {
        return "error";
    }
    return "warning";
};
